import { type MantineColor, Text } from '@mantine/core';
import { useClipboard } from '@mantine/hooks';
import { showSuccessNotification } from '@vrplatform/theme';

type CopyableReferenceProps = {
  label: string;
  value: string;
  color?: MantineColor;
};

export const CopyableReference = ({
  label,
  value,
  color,
}: CopyableReferenceProps) => {
  const { copy } = useClipboard();

  const copyReference = () => {
    copy(value);
    showSuccessNotification({
      message: `${label} copied to clipboard`,
      icon: null,
      autoClose: 1000,
    });
  };

  return (
    <Text
      component="button"
      type="button"
      c={color}
      size="xs"
      aria-label={`Copy ${label} ${value}`}
      onClick={copyReference}
      sx={(theme) => ({
        appearance: 'none',
        background: 'transparent',
        border: 0,
        cursor: 'pointer',
        display: 'inline',
        margin: 0,
        padding: 0,
        textAlign: 'left',
        '&:hover': {
          textDecoration: 'underline',
          textUnderlineOffset: 4,
          textDecorationColor: theme.colors[color || 'neutral'][5],
        },
        '&:focus-visible': {
          outline: `2px solid ${theme.colors[theme.primaryColor][6]}`,
          outlineOffset: 2,
        },
      })}
    >
      {value}
    </Text>
  );
};

type CopyableCsvReferenceProps = {
  reference: string;
  color?: MantineColor;
};

export const CopyableCsvReference = ({
  reference,
  color,
}: CopyableCsvReferenceProps) => (
  <CopyableReference label="CSV reference" value={reference} color={color} />
);
